export default __webpack_public_path__ + "static/media/sell.04a535fc.svg";